export const NAME = 'auth'

export const types = {
  SESSION_REQUEST: 'auth/SESSION_REQUEST',
  SESSION_SUCCESS: 'auth/SESSION_SUCCESS',
  SESSION_FAILURE: 'auth/SESSION_FAILURE',

  LOGIN_REQUEST: 'auth/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'auth/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'auth/LOGIN_FAILURE',

  LOGOUT_REQUEST: 'auth/LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'auth/LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'auth/LOGOUT_FAILURE',

  // Dispatched by sessionMiddleware when any API call comes back 401, so an
  // expired cookie drops the user on the login screen instead of an empty page.
  SESSION_EXPIRED: 'auth/SESSION_EXPIRED',
}

// `checking` keeps the login form from flashing before /api/auth/me answers.
const initialState = {
  status: 'checking',
  login: null,
  pending: false,
  error: null,
}

const loginFrom = (payload) => (payload && payload.data && payload.data.login) || null

const errorFor = (payload) => {
  const type = payload && payload.response && payload.response.data && payload.response.data.type

  if (type === 'TooManyAttempts') {
    return 'Слишком много попыток. Попробуйте через 15 минут.'
  }

  if (type === 'InvalidCredentials' || type === 'MissingCredentials') {
    return 'Неверный логин или пароль.'
  }

  return 'Не удалось войти. Попробуйте ещё раз.'
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SESSION_REQUEST:
      return { ...state, status: 'checking' }

    case types.SESSION_SUCCESS:
      return { ...state, status: 'authenticated', login: loginFrom(action.payload), error: null }

    case types.SESSION_FAILURE:
      return { ...state, status: 'anonymous', login: null }

    case types.LOGIN_REQUEST:
      return { ...state, pending: true, error: null }

    case types.LOGIN_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
        status: 'authenticated',
        login: loginFrom(action.payload),
      }

    case types.LOGIN_FAILURE:
      return { ...state, pending: false, status: 'anonymous', error: errorFor(action.payload) }

    case types.LOGOUT_SUCCESS:
    case types.LOGOUT_FAILURE:
    case types.SESSION_EXPIRED:
      return { ...initialState, status: 'anonymous' }

    default:
      return state
  }
}

export default reducer
